/* eslint-disable max-len */
export default `
{
    "Titulo": "Template de exemplo",
    "NumeroPedido": "\${orderNumber}",
    "CodigoTransportadora": "\${orderTransporterCode}"
}
`;
